export default __webpack_public_path__ + "static/media/cancel.96cfe95d.svg";